var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    viewBox: "0 0 48 48",
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 36,24 c -2,0 -4,0 -6,0 2.666667,2.666667 5.333333,5.333333 8,8 2.666667,-2.666667 5.333333,-5.333333 8,-8 -2,0 -4,0 -6,0 C 40.129122,16.892603 34.905254,10.166479 27.999799,8.5035095 23.788802,7.3977357 19.1447,8.1297774 15.48,10.48 c 0.973333,0.973333 1.946667,1.946667 2.92,2.92 5.015764,-2.808983 11.875926,-1.243756 15.216784,3.419099 C 35.161103,18.872342 36.008648,21.431072 36,24 Z M 32.52,37.52 C 31.546667,36.546667 30.573333,35.573333 29.6,34.6 24.584236,37.408983 17.724074,35.843756 14.383216,31.180901 12.839283,29.128637 11.991045,26.56787 12,24 c 2,0 4,0 6,0 -2.666667,-2.666667 -5.333333,-5.333333 -8,-8 -2.6666667,2.666667 -5.3333333,5.333333 -8,8 2,0 4,0 6,0 -0.1291216,7.107397 5.094746,13.833521 12.000201,15.49649 4.216704,1.105082 8.84966,0.375015 12.519799,-1.97649 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "none",
    d: "M0 0h48v48H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.271c109db93dafc2f23b7911c4870484.svg";
export { ForwardRef as ReactComponent };